'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopifySection = exports.deregister = exports.register = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sections = {}; /*
                    *  Shopify Section Class
                    *    Provides common API, as well as easy initalization for Shopify Sections
                    *
                    *  Version:
                    *    1.0.0 - 2019/01/08
                    */

var register = exports.register = function register(selector, initializer) {
  return Sections[selector] = initializer;
};
var deregister = exports.deregister = function deregister(selector) {
  return delete Sections[selector];
};

var ShopifySection =
//container - jQuery container element
exports.ShopifySection = function ShopifySection(container) {
  (0, _classCallCheck3.default)(this, ShopifySection);

  this.container = container;

  //Only sections that are really sections can be.. sections
  this.isSection = this.container.attr('data-section') && this.container.attr('data-section-id');

  //Get attributes
  if (this.isSection) {
    this.class = this.container.attr('class');
    this.id = this.container.attr('data-section-id');
  }
};

//Initialize


(0, _jquery2.default)(document).ready(function () {
  var keys = Object.keys(Sections);
  keys.forEach(function (selector) {
    var init = Sections[selector];
    (0, _jquery2.default)(selector).each(function (i, e) {
      new init((0, _jquery2.default)(e));
    });
  });
});